import React from "react";
import { Helmet } from "react-helmet-async";
import ScrollToTopButton from "../components/ScrollToTopButton";

const TermsAndConditions = () => {
  return (
    <>
      <div className="min-h-screen bg-white py-8 px-2 md:py-12 md:px-4">
        <Helmet>
          <title>Terms and Conditions | VOICE</title>
          <meta
            name="description"
            content="Terms and Conditions governing the use of VOICE (EV91Technologies) rider and rental services."
          />
        </Helmet>

        <div className="max-w-3xl mx-auto bg-white/90 rounded-lg shadow-lg p-4 md:p-8 text-gray-800">
          <h1 className="text-3xl md:text-4xl font-bold mb-6 text-green-800">
            Terms and Conditions
          </h1>

          <p className="mb-4 text-gray-700">
            Last updated: October 21, 2025
          </p>
        
          <p className="mb-6 text-gray-700">
            These Terms and Conditions govern the use of services provided by
            <strong> VOICE (EV91Technologies Pvt Ltd)</strong>. By accessing,
            registering, or using our services, you agree to be bound by these
            Terms and Conditions.
          </p>

          {/* Service Usage */}
          <h2 className="text-2xl font-semibold mt-8 mb-2 text-green-800">
            Use of Services
          </h2>

          <p className="mb-4 text-gray-700">
            VOICE provides electric vehicle rental and rider support services.
            Services must be used only for lawful delivery and transportation
            purposes.
          </p>

          {/* Exit Policy */}
          <h2 className="text-2xl font-semibold mt-8 mb-2 text-green-800">
            Exit Policy
          </h2>

          <p className="mb-4 text-gray-700">
            Riders who wish to exit the company must provide at least
            <strong> 7 days prior notice</strong>.
          </p>

          <p className="mb-4 text-gray-700">
            Exit is subject to vehicle return, document verification, and
            clearance of all pending obligations.
          </p>

          {/* Payments */}
          <h2 className="text-2xl font-semibold mt-8 mb-2 text-green-800">
            Payments
          </h2>

          <p className="mb-4 text-gray-700">
            All payments must be made through authorized digital payment methods
            provided by the platform.
          </p>

          <p className="mb-4 text-gray-700">
            VOICE does not store sensitive payment information such as UPI PINs,
            card numbers, or CVV details.
          </p>

          {/* Responsibilities */}
          <h2 className="text-2xl font-semibold mt-8 mb-2 text-green-800">
            Rider Responsibilities
          </h2>

          <ul className="list-disc ml-6 text-gray-700 mb-4">
            <li>Use the vehicle responsibly and legally</li>
            <li>Follow traffic rules and safety guidelines</li>
            <li>Maintain the vehicle in good condition</li>
            <li>Clear dues and payments on time</li>
          </ul>

          {/* Policy Reference */}
          <h2 className="text-2xl font-semibold mt-8 mb-2 text-green-800">
            Pricing & Refund Policy
          </h2>

          <p className="mb-4 text-gray-700">
            Pricing details, security deposits, cancellation rules, and refund
            timelines are governed by our{" "}
            <strong>Pricing & Refund Policy</strong>, available separately on
            the website.
          </p>

          {/* Changes */}
          <h2 className="text-2xl font-semibold mt-8 mb-2 text-green-800">
            Changes to Terms
          </h2>

          <p className="mb-4 text-gray-700">
            VOICE reserves the right to modify these Terms and Conditions at any
            time. Continued use of the services implies acceptance of the
            updated terms.
          </p>

          {/* Contact */}
          <h2 className="text-2xl font-semibold mt-8 mb-2 text-green-800">
            Contact Us
          </h2>

          <ul className="list-disc ml-6 text-gray-700 mb-4">
            <li>Email: info@ev91riderz.com</li>
            <li>
              Address: Site No. 23, A.V.S. Compound, 80 Feet Rd, 4th Block,
              Koramangala, Bengaluru, Karnataka – 560095
            </li>
          </ul>
        </div>

        <ScrollToTopButton />
      </div>
    </>
  );
};

export default TermsAndConditions;
